<template>
  <div>
    <b-modal ref="createRequestItemModal"
             :title="title" :no-close-on-backdrop="true">
      <b-row v-if="isNewItem">
        <b-col>
          <label>{{$t('labels.common.smart_search')}}</label>
        </b-col>
      </b-row>
      <b-row v-if="isNewItem">
        <b-col cols="11">
          <input class="form-control" v-model="searchData.text" :disabled="!isNewItem" @keyup.enter="searchLot"
                 placeholder="">
        </b-col>
        <b-col>
          <img src="@/assets/images/common-icons/icon_search.svg" @click="searchLot" height="20"
               :title="$t('buttons.common.search')">
        </b-col>
      </b-row>
      <b-row v-if="isNewItem">
        <b-col>
          <label>{{$t('labels.lots.lot_descr')}}</label>
          <multiselect v-model="requestItemData.lot" :max-height="200"
                       placeholder="Choose lot" label="description" track-by="id"
                       :options="lotsForSelect"
                       :class="{ required: (!requestItemData.lot) }"
                       :show-labels="false" @select="autoComplete"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row v-if="!isNewItem">
        <b-col>
          <label>{{$t('labels.lots.lot_number')}}</label>
          <multiselect v-model="requestItemData.lot" :max-height="200"
                       :options="lotsForSelect"
                       placeholder="" label="lot_nr" track-by="id"
                       :disabled="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
          <multiselect v-model="requestItemData.wood" :max-height="200"
                       placeholder="Choose wood" label="name" track-by="id"
                       :options="wood"
                       @select="selectHumidity"
                       :show-labels="false"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
          <multiselect v-model="requestItemData.quality" :max-height="200"
                       placeholder="Choose quality" label="name" track-by="id"
                       :options="qualities_list"
                       :show-labels="false"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.humidity')}}</label>
          <multiselect v-model="requestItemData.humidity" :max-height="200"
                       placeholder="Choose humidity"
                       :options="humidity"
                       :show-labels="false"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.delivery_date')}}</label>
          <datepicker v-model="requestItemData.delivery_term" lang="en"
                      :disabled="true" :first-day-of-week="1"
          ></datepicker>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.pricePerm3')}}</label>
          <input class="form-control" v-model="requestItemData.price_per_unit"
                 v-digits-after-decimal="{numberOfDigits: 2}"
                 placeholder="Enter price">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.currency')}}</label>
          <input class="form-control" v-model="requestItemData.currency"
                 placeholder="" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.thickness')}}</label>
          <input class="form-control" v-model="requestItemData.thickness_nominal"
                 :class="{ required: (!requestItemData.thickness_nominal) }"
                 v-replace-with-positive
                 :placeholder="thickness_limit">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.width')}}</label>
          <input class="form-control" v-model="requestItemData.width_nominal"
                 :class="{ required: (!requestItemData.width_nominal) }"
                 v-replace-with-positive
                 :placeholder="width_limit">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.length')}}</label>
          <input class="form-control" v-model="requestItemData.length_nominal"
                 :class="{ required: (!requestItemData.length_nominal) }"
                 v-replace-with-positive
                 :placeholder="length_limit">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.ordered')}}</label>
          <input class="form-control" v-model="requestItemData.amount"
                 v-digits-after-decimal="{numberOfDigits: 3}"
                 placeholder="Enter quantity ordered">
        </b-col>
        <b-col>
          <label>{{$t('labels.lots.lot_delta')}}</label>
          <input class="form-control" v-model="requestItemData.delta"
                 :disabled="true"
                 placeholder="">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.measure_type')}}</label>
          <input class="form-control" v-model="requestItemData.measure_type"
                 placeholder="" :disabled="true">
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="success" @click="createItem('save')">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="createItem('add_another')" :disabled="!isNewItem">
          {{$t('buttons.common.save_add_more')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import {
    cleanFilters,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';

  export default {
    props: ['requestID', 'delivery_term'],
    components: {
      Multiselect,
      Datepicker
    },
    data() {
      return {
        humidity: [],
        isNewItem: true,
        descr: [],
        lotsForSelect: [],
        width_limit: '',
        length_limit: '',
        thickness_limit: '',
        requestItemData: {
          lot: '',
          wood: [],
          thickness_nominal: '',
          width_nominal: '',
          length_nominal: '',
          quality: '',
          humidity: '',
          measure_type: '',
          amount: '',
          price_per_unit: '',
          currency: '',
          delivery_term: null,
          delta: ''
        },
        searchData: {
          text: '',
          status: 'active'
        }
      }
    },
    methods: {
      loadSettings() {
        this.$store.dispatch('lots/loadLots');
        this.$store.cache.dispatch('woodware/getWood');
        this.$store.cache.dispatch('woodware/getQualitiesList');
        this.searchLot();
      },
      createItem(event) {
        const saveData = {
          ...this.requestItemData,
          request_order: this.requestID,
          lot: this.requestItemData.lot ? this.requestItemData.lot.id : '',
          quality: this.requestItemData.quality ? this.requestItemData.quality.id : '',
          wood: this.requestItemData.wood ? this.requestItemData.wood.id : '',
          delivery_term: this.requestItemData.delivery_term ? moment(this.requestItemData.delivery_term).format(DATE_FORMAT) : ''
        }
        if (this.checkTWL) {
          if (this.isNewItem) {
            this.$http.post(`purchase/request_items/`, saveData)
              .then(handlerResponse).then((response) => {
              this.$notify(setNotifyData('Success', 'Request item has been created!', 'success'));
              this.$root.$emit('updateRequestOrderInfo', response);
              this.$store.dispatch('requests/loadRequestItems', {request_order_id: this.requestID});
              if (event === 'add_another') {
                cleanFilters(this.requestItemData);
                this.setLimits();
              } else {
                this.$refs['createRequestItemModal'].hide();
              }
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            })
          } else {
            this.$http.put(`purchase/request_items/${this.requestItemData.id}/`, saveData).then(handlerResponse).then(() => {
              this.$store.dispatch('requests/loadRequestItems', {request_order_id: this.requestID});
              this.$notify(setNotifyData('Success', 'Request item has been saved!', 'success'));
              this.$refs['createRequestItemModal'].hide();
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            });
          }
        }
      },
      selectHumidity(event) {
        this.humidity = event.humidity_list;
      },
      autoComplete(event) {
        this.$http.get(`purchase/lots/${event.id}/`).then(handlerResponse).then((response) => {
          delete response.delivery_term;
          this.requestItemData = {...this.requestItemData, ...response};
          this.requestItemData.amount = 0;
        }).then(() => {
          this.setLimits()
        });
      },
      searchLot() {
        this.$http.get(`purchase/lots/search_by_description/`, {params: this.searchData})
          .then(handlerResponse).then((response) => {
          this.lotsForSelect = response;
        }).catch((error) => {
          console.log(error);
          notificationsRenderer(error.body, 'error');
        })
      },
      setLimits() {
        if (this.requestItemData.length_nominal_from !== '' && this.requestItemData.width_nominal_from !== '' && this.requestItemData.thickness_nominal_from !== ''
          && this.requestItemData.length_nominal_to && this.requestItemData.width_nominal_to && this.requestItemData.thickness_nominal_to) {
          this.length_limit = `from ${this.requestItemData.length_nominal_from} to  ${this.requestItemData.length_nominal_to} `;
          this.width_limit = `from ${this.requestItemData.width_nominal_from} to ${this.requestItemData.width_nominal_to} `;
          this.thickness_limit = `from ${this.requestItemData.thickness_nominal_from} to ${this.requestItemData.thickness_nominal_to} `;
        } else {
          this.width_limit = '';
          this.length_limit = '';
          this.thickness_limit = '';
        }
      }
    },
    mounted() {
      this.$root.$on('openCreateRequestItemModal', (selectedRequestItem) => {
        this.loadSettings();
        if (this.$refs['createRequestItemModal']) {
          this.isNewItem = true;
          this.$refs['createRequestItemModal'].show();
        }
        if (selectedRequestItem) {
          this.isNewItem = false;
          this.requestItemData = selectedRequestItem;
          this.setLimits();
        } else {
          cleanFilters(this.requestItemData);
          this.requestItemData.delivery_term = this.delivery_term;
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openCreateRequestItemModal');
    },
    computed: {
      ...mapState('woodware', ['wood', 'qualities_list']),
      title() {
        return this.isNewItem ? `${this.$i18n.t('modal_dialogs.purchase_request_item.add_request_item')}` : `${this.$i18n.t('modal_dialogs.purchase_request_item.edit_request_item')}`;
      },
      checkTWL() {
        if (Number(this.requestItemData.thickness_nominal) < Number(this.requestItemData.thickness_nominal_from) || Number(this.requestItemData.thickness_nominal) > Number(this.requestItemData.thickness_nominal_to) || !this.requestItemData.thickness_nominal) {
          this.$notify(setNotifyData('', 'Thickness is incorrect', 'error'));
          return false
        } else if (Number(this.requestItemData.width_nominal) < Number(this.requestItemData.width_nominal_from) || Number(this.requestItemData.width_nominal) > Number(this.requestItemData.width_nominal_to) || !this.requestItemData.width_nominal) {
          this.$notify(setNotifyData('', 'Width is incorrect', 'error'));
          return false
        } else if (Number(this.requestItemData.length_nominal) < Number(this.requestItemData.length_nominal_from) || Number(this.requestItemData.length_nominal) > Number(this.requestItemData.length_nominal_to) || !this.requestItemData.length_nominal) {
          this.$notify(setNotifyData('', 'Length is incorrect', 'error'));
          return false
        } else {
          return true
        }
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modals/PurchaseRequestItemModal.vue